import type { PrivateEventDetail } from '../../api/privateEvents';
import { EditSection } from '../shared/EditSection';

import ClientDealForm from './ClientDealForm';
import ClientDealView from './ClientDealView';
import { useClientDealForm } from './use-client-deal-form';

export default function ClientDealSection({
  event,
  readOnly,
  denied,
  onDenied,
}: {
  event: PrivateEventDetail;
  readOnly: boolean;
  denied: boolean;
  onDenied: () => void;
}) {
  const form = useClientDealForm(event, onDenied);
  return (
    <EditSection
      title="Client & deal"
      editLabel="Edit Client & deal"
      readOnly={readOnly}
      frozen={denied}
      onEdit={form.begin}
      onCancel={form.begin}
      onSave={form.submit}
      view={<ClientDealView event={event} />}
      form={<ClientDealForm form={form} />}
    />
  );
}
